import { render, staticRenderFns } from "./DeleteRoomDecorationRecord.vue?vue&type=template&id=66cf37ab&scoped=true"
import script from "./DeleteRoomDecorationRecord.vue?vue&type=script&lang=js"
export * from "./DeleteRoomDecorationRecord.vue?vue&type=script&lang=js"
import style0 from "./DeleteRoomDecorationRecord.vue?vue&type=style&index=0&id=66cf37ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cf37ab",
  null
  
)

export default component.exports